export default "__VITE_ASSET__d573c517__"